// 1. React and DOM imports
import type { ReactNode } from 'react';

// 2. Internal components
import { LogoBrand } from './LogoBrand';
import { PAGE_GRADIENT_BACKGROUND } from './pageBackground';
import { cn } from '~/lib/utils';

// 4. Type imports
import type { LogoBrandSize } from './LogoBrand';

interface SinglePurposePageLayoutProps {
  children: ReactNode;
  showLogo?: boolean;
  logoSize?: LogoBrandSize;
}

/**
 * SinglePurposePageLayout
 *
 * Reusable layout component for single-purpose pages (OAuth, Telegram connect, etc).
 * Provides a consistent centered max-width column, gradient background, and optional centered LogoBrand header.
 *
 * Per §TS.3.1: Function declaration for named export
 * Per §TS.3.2: Descriptive props interface with explicit types
 */
export function SinglePurposePageLayout({
  children,
  showLogo = true,
  logoSize = 'large',
}: SinglePurposePageLayoutProps) {
  return (
    <div className={cn('flex min-h-screen flex-col', PAGE_GRADIENT_BACKGROUND)}>
      <div className="mx-auto max-w-screen-sm px-4 py-8">
        {showLogo && (
          <div className="mb-8 flex justify-center">
            <LogoBrand size={logoSize} />
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
